import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import * as H from "react";
import { useState as ye, useEffect as he } from "react";
import { c as ne, q as xe, m as be } from "./tss-DN0acMKN.mjs";
import { M as Re, d as Fe } from "./constants-CnFYFetN.mjs";
import { I as Z } from "./icon-v2-DGtVEk7e.mjs";
import { L as ee } from "./layout-box-DFBM-kSI.mjs";
import { g as Se, c as U } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { u as Ve } from "./index-CLU0MTzP.mjs";
import { c as ie } from "./createSvgIcon-ButWPptu.mjs";
import { m as se } from "./memoTheme-BzXKG_-k.mjs";
import { s as X, d as Ce, u as Ae, c as Me } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { g as je } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { v as we } from "./visuallyHidden-B8J7BVSJ.mjs";
import { u as ae } from "./useId-CK6Kn3Tn.mjs";
import { u as Le } from "./useControlled-ZIJRsfP8.mjs";
import { u as ze } from "./useForkRef-C_4o__cU.mjs";
import { i as oe } from "./isFocusVisible-CLflI_-N.mjs";
const Ee = ie(/* @__PURE__ */ t.jsx("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star"), He = ie(/* @__PURE__ */ t.jsx("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), "StarBorder");
function Ie(o) {
  return Se("MuiRating", o);
}
const P = je("MuiRating", ["root", "sizeSmall", "sizeMedium", "sizeLarge", "readOnly", "disabled", "focusVisible", "visuallyHidden", "pristine", "label", "labelEmptyValueActive", "icon", "iconEmpty", "iconFilled", "iconHover", "iconFocus", "iconActive", "decimal"]);
function $e(o) {
  const e = o.toString().split(".")[1];
  return e ? e.length : 0;
}
function G(o, e) {
  if (o == null)
    return o;
  const n = Math.round(o / e) * e;
  return Number(n.toFixed($e(e)));
}
const Oe = (o) => {
  const {
    classes: e,
    size: n,
    readOnly: d,
    disabled: r,
    emptyValueFocused: y,
    focusVisible: c
  } = o, h = {
    root: ["root", `size${ne(n)}`, r && "disabled", c && "focusVisible", d && "readOnly"],
    label: ["label", "pristine"],
    labelEmptyValue: [y && "labelEmptyValueActive"],
    icon: ["icon"],
    iconEmpty: ["iconEmpty"],
    iconFilled: ["iconFilled"],
    iconHover: ["iconHover"],
    iconFocus: ["iconFocus"],
    iconActive: ["iconActive"],
    decimal: ["decimal"],
    visuallyHidden: ["visuallyHidden"]
  };
  return Me(h, Ie, e);
}, Ne = X("span", {
  name: "MuiRating",
  slot: "Root",
  overridesResolver: (o, e) => {
    const {
      ownerState: n
    } = o;
    return [{
      [`& .${P.visuallyHidden}`]: e.visuallyHidden
    }, e.root, e[`size${ne(n.size)}`], n.readOnly && e.readOnly];
  }
})(se(({
  theme: o
}) => ({
  display: "inline-flex",
  // Required to position the pristine input absolutely
  position: "relative",
  fontSize: o.typography.pxToRem(24),
  color: "#faaf00",
  cursor: "pointer",
  textAlign: "left",
  width: "min-content",
  WebkitTapHighlightColor: "transparent",
  [`&.${P.disabled}`]: {
    opacity: (o.vars || o).palette.action.disabledOpacity,
    pointerEvents: "none"
  },
  [`&.${P.focusVisible} .${P.iconActive}`]: {
    outline: "1px solid #999"
  },
  [`& .${P.visuallyHidden}`]: we,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: o.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: o.typography.pxToRem(30)
    }
  }, {
    // TODO v6: use the .Mui-readOnly global state class
    props: ({
      ownerState: e
    }) => e.readOnly,
    style: {
      pointerEvents: "none"
    }
  }]
}))), le = X("label", {
  name: "MuiRating",
  slot: "Label",
  overridesResolver: ({
    ownerState: o
  }, e) => [e.label, o.emptyValueFocused && e.labelEmptyValueActive]
})({
  cursor: "inherit",
  variants: [{
    props: ({
      ownerState: o
    }) => o.emptyValueFocused,
    style: {
      top: 0,
      bottom: 0,
      position: "absolute",
      outline: "1px solid #999",
      width: "100%"
    }
  }]
}), Pe = X("span", {
  name: "MuiRating",
  slot: "Icon",
  overridesResolver: (o, e) => {
    const {
      ownerState: n
    } = o;
    return [e.icon, n.iconEmpty && e.iconEmpty, n.iconFilled && e.iconFilled, n.iconHover && e.iconHover, n.iconFocus && e.iconFocus, n.iconActive && e.iconActive];
  }
})(se(({
  theme: o
}) => ({
  // Fit wrapper to actual icon size.
  display: "flex",
  transition: o.transitions.create("transform", {
    duration: o.transitions.duration.shortest
  }),
  // Fix mouseLeave issue.
  // https://github.com/facebook/react/issues/4492
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: e
    }) => e.iconActive,
    style: {
      transform: "scale(1.2)"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.iconEmpty,
    style: {
      color: (o.vars || o).palette.action.disabled
    }
  }]
}))), Te = X("span", {
  name: "MuiRating",
  slot: "Decimal",
  shouldForwardProp: (o) => Ce(o) && o !== "iconActive",
  overridesResolver: (o, e) => {
    const {
      iconActive: n
    } = o;
    return [e.decimal, n && e.iconActive];
  }
})({
  position: "relative",
  variants: [{
    props: ({
      iconActive: o
    }) => o,
    style: {
      transform: "scale(1.2)"
    }
  }]
});
function ke(o) {
  const {
    value: e,
    ...n
  } = o;
  return /* @__PURE__ */ t.jsx("span", {
    ...n
  });
}
function te(o) {
  const {
    classes: e,
    disabled: n,
    emptyIcon: d,
    focus: r,
    getLabelText: y,
    highlightSelectedOnly: c,
    hover: h,
    icon: x,
    IconContainerComponent: b,
    isActive: M,
    itemValue: a,
    labelProps: S,
    name: m,
    onBlur: I,
    onChange: R,
    onClick: p,
    onFocus: V,
    readOnly: T,
    ownerState: l,
    ratingValue: f,
    ratingValueRounded: W
  } = o, j = c ? a === f : a <= f, k = a <= h, w = a <= r, Y = a === W, $ = `${m}-${ae()}`, C = /* @__PURE__ */ t.jsx(Pe, {
    as: b,
    value: a,
    className: U(e.icon, j ? e.iconFilled : e.iconEmpty, k && e.iconHover, w && e.iconFocus, M && e.iconActive),
    ownerState: {
      ...l,
      iconEmpty: !j,
      iconFilled: j,
      iconHover: k,
      iconFocus: w,
      iconActive: M
    },
    children: d && !j ? d : x
  });
  return T ? /* @__PURE__ */ t.jsx("span", {
    ...S,
    children: C
  }) : /* @__PURE__ */ t.jsxs(H.Fragment, {
    children: [/* @__PURE__ */ t.jsxs(le, {
      ownerState: {
        ...l,
        emptyValueFocused: void 0
      },
      htmlFor: $,
      ...S,
      children: [C, /* @__PURE__ */ t.jsx("span", {
        className: e.visuallyHidden,
        children: y(a)
      })]
    }), /* @__PURE__ */ t.jsx("input", {
      className: e.visuallyHidden,
      onFocus: V,
      onBlur: I,
      onChange: R,
      onClick: p,
      disabled: n,
      value: a,
      id: $,
      type: "radio",
      name: m,
      checked: Y
    })]
  });
}
const Be = /* @__PURE__ */ t.jsx(Ee, {
  fontSize: "inherit"
}), De = /* @__PURE__ */ t.jsx(He, {
  fontSize: "inherit"
});
function Ue(o) {
  return `${o || "0"} Star${o !== 1 ? "s" : ""}`;
}
const Xe = /* @__PURE__ */ H.forwardRef(function(e, n) {
  const d = Ae({
    name: "MuiRating",
    props: e
  }), {
    className: r,
    defaultValue: y = null,
    disabled: c = !1,
    emptyIcon: h = De,
    emptyLabelText: x = "Empty",
    getLabelText: b = Ue,
    highlightSelectedOnly: M = !1,
    icon: a = Be,
    IconContainerComponent: S = ke,
    max: m = 5,
    name: I,
    onChange: R,
    onChangeActive: p,
    onMouseLeave: V,
    onMouseMove: T,
    precision: l = 1,
    readOnly: f = !1,
    size: W = "medium",
    value: j,
    ...k
  } = d, w = ae(I), [Y, $] = Le({
    controlled: j,
    default: y,
    name: "Rating"
  }), C = G(Y, l), re = Ve(), [{
    hover: v,
    focus: B
  }, O] = H.useState({
    hover: -1,
    focus: -1
  });
  let L = C;
  v !== -1 && (L = v), B !== -1 && (L = B);
  const [ce, _] = H.useState(!1), J = H.useRef(), ue = ze(J, n), de = (i) => {
    T && T(i);
    const s = J.current, {
      right: u,
      left: D,
      width: z
    } = s.getBoundingClientRect();
    let E;
    re ? E = (u - i.clientX) / z : E = (i.clientX - D) / z;
    let g = G(m * E + l / 2, l);
    g = xe(g, l, m), O((A) => A.hover === g && A.focus === g ? A : {
      hover: g,
      focus: g
    }), _(!1), p && v !== g && p(i, g);
  }, me = (i) => {
    V && V(i);
    const s = -1;
    O({
      hover: s,
      focus: s
    }), p && v !== s && p(i, s);
  }, K = (i) => {
    let s = i.target.value === "" ? null : parseFloat(i.target.value);
    v !== -1 && (s = v), $(s), R && R(i, s);
  }, pe = (i) => {
    i.clientX === 0 && i.clientY === 0 || (O({
      hover: -1,
      focus: -1
    }), $(null), R && parseFloat(i.target.value) === C && R(i, null));
  }, fe = (i) => {
    oe(i.target) && _(!0);
    const s = parseFloat(i.target.value);
    O((u) => ({
      hover: u.hover,
      focus: s
    }));
  }, ve = (i) => {
    if (v !== -1)
      return;
    oe(i.target) || _(!1);
    const s = -1;
    O((u) => ({
      hover: u.hover,
      focus: s
    }));
  }, [ge, Q] = H.useState(!1), N = {
    ...d,
    defaultValue: y,
    disabled: c,
    emptyIcon: h,
    emptyLabelText: x,
    emptyValueFocused: ge,
    focusVisible: ce,
    getLabelText: b,
    icon: a,
    IconContainerComponent: S,
    max: m,
    precision: l,
    readOnly: f,
    size: W
  }, F = Oe(N);
  return /* @__PURE__ */ t.jsxs(Ne, {
    ref: ue,
    onMouseMove: de,
    onMouseLeave: me,
    className: U(F.root, r, f && "MuiRating-readOnly"),
    ownerState: N,
    role: f ? "img" : null,
    "aria-label": f ? b(L) : null,
    ...k,
    children: [Array.from(new Array(m)).map((i, s) => {
      const u = s + 1, D = {
        classes: F,
        disabled: c,
        emptyIcon: h,
        focus: B,
        getLabelText: b,
        highlightSelectedOnly: M,
        hover: v,
        icon: a,
        IconContainerComponent: S,
        name: w,
        onBlur: ve,
        onChange: K,
        onClick: pe,
        onFocus: fe,
        ratingValue: L,
        ratingValueRounded: C,
        readOnly: f,
        ownerState: N
      }, z = u === Math.ceil(L) && (v !== -1 || B !== -1);
      if (l < 1) {
        const E = Array.from(new Array(1 / l));
        return /* @__PURE__ */ t.jsx(Te, {
          className: U(F.decimal, z && F.iconActive),
          ownerState: N,
          iconActive: z,
          children: E.map((g, A) => {
            const q = G(u - 1 + (A + 1) * l, l);
            return /* @__PURE__ */ t.jsx(te, {
              ...D,
              // The icon is already displayed as active
              isActive: !1,
              itemValue: q,
              labelProps: {
                style: E.length - 1 === A ? {} : {
                  width: q === L ? `${(A + 1) * l * 100}%` : "0%",
                  overflow: "hidden",
                  position: "absolute"
                }
              }
            }, q);
          })
        }, u);
      }
      return /* @__PURE__ */ t.jsx(te, {
        ...D,
        isActive: z,
        itemValue: u
      }, u);
    }), !f && !c && /* @__PURE__ */ t.jsxs(le, {
      className: U(F.label, F.labelEmptyValue),
      ownerState: N,
      children: [/* @__PURE__ */ t.jsx("input", {
        className: F.visuallyHidden,
        value: "",
        id: `${w}-empty`,
        type: "radio",
        name: w,
        checked: C == null,
        onFocus: () => Q(!0),
        onBlur: () => Q(!1),
        onChange: K
      }), /* @__PURE__ */ t.jsx("span", {
        className: F.visuallyHidden,
        children: x
      })]
    })]
  });
}), We = be()(({ spacing: o, mode: e }) => ({
  root: {
    marginLeft: `-${o(0.5)}`,
    // Takes care of the extra padding on the first icon in the rating component
    outline: e === Re.Dye ? `1px solid ${Fe.main}` : void 0
  },
  large: {
    "& > label": {
      marginLeft: "1px"
    }
  }
})), co = (o) => {
  const {
    classes: e = {},
    max: n = 5,
    onChange: d,
    icon: r = "star-solid",
    emptyIcon: y,
    size: c = "medium",
    precision: h = 1,
    value: x
  } = o, { classes: b, cx: M } = We(), a = (p) => {
    switch (p) {
      case "small":
        return 12;
      case "medium":
        return 16;
      case "large":
        return 40;
      default:
        return 16;
    }
  }, [S, m] = ye(x);
  he(() => {
    m(x);
  }, [x]);
  const I = typeof r == "string" ? /* @__PURE__ */ t.jsx(ee, { marginLeft: 0.5, children: /* @__PURE__ */ t.jsx(Z, { color: "notice-strong", name: r, size: a(c) }) }) : r, R = typeof r == "string" ? /* @__PURE__ */ t.jsx(ee, { marginLeft: 0.5, children: /* @__PURE__ */ t.jsx(Z, { color: "neutral-extra-weak", name: r, size: a(c) }) }) : r;
  return /* @__PURE__ */ t.jsx(
    Xe,
    {
      ...o,
      classes: e,
      className: M(b.root, e.root, {
        [b.large]: c === "large"
      }),
      "data-fabric-component": "Rating",
      emptyIcon: y || R,
      icon: I,
      max: n,
      onChange: (p, V) => {
        m(V), typeof d == "function" && d(p, V);
      },
      precision: h || 1,
      size: c,
      value: S
    }
  );
};
export {
  co as R
};
//# sourceMappingURL=rating-CHKRO0eU.mjs.map
